export enum USER_REQUEST_STATUS_NAME {
    PENDING = 'pending',
    APPROVED = 'approved',
    CANCELED = 'canceled',
}
